<template>
  <button type="button" :title="titleText" class="share btn btn-outline-dark"
          :class="[channel.medium, {'d-md-none': channel.mobileOnly}]" v-bind="$attrs"
          @click="$emit('click')">
    <i :class="iconCssClass" />

    <span class="d-none" :class="{'d-lg-inline': showButtonLabels}">
      {{ labelText }}
    </span>
  </button>
</template>

<script>
import kebabCase from 'lodash/kebabCase'

export default {
  props: {
    channel: {
      type: Object,
      required: true
    },

    iconClass: {
      type: String,
      required: false
    },

    label: {
      type: String,
      required: false
    },

    showButtonLabels: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: false
    }
  },

  emits: ['click'],

  computed: {
    iconCssClass() {
      return this.iconClass || `icon-${kebabCase(this.channel.kind)}`
    },

    labelText() {
      return this.label || this.i18n.t(`public.social.${this.channel.medium}`)
    },

    titleText() {
      return this.title || this.i18n.t(`public.social.share_on_${this.channel.medium}`)
    }
  }
}
</script>

<style lang="scss" scoped>
i + span {
  margin-left: 10px;
}
</style>
